export const headersLogs = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Data/Hora', width: 10, key: 'Data/Hora' },
  { text: 'Usuário', width: 8, key: 'Usuário' },
  { text: 'Entidade', width: 5, key: 'entidade' },
  { text: 'Registro', width: 5, key: 'registroId' },
  { text: 'Ação', width: 5, key: 'Ação' },
  { text: 'Detalhamento', width: 20, key: 'Detalhamento' },
  { text: 'Alterações', width: 20, key: 'alteracoes' },
];

export const valoresExibidosLogs: Record<string, string> = {
  id: 'ID',
  usuarioSisaf: 'Usuário',
  dataAcao: 'Data da Ação',
  interfaceSisAf: 'Interface SisAF',
  tipoAcao: 'Tipo de Ação',
  entidade: 'Entidade',
  registroId: 'ID do registro',
  nomeCompleto: 'Usuário',
  detalhamento: 'Detalhamento',
};

export const fieldObjectLogs = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'nomeCompleto',
];
